function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.988,
  cy: 15.014,
  rx: 11.655,
  ry: 11.125,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 3.48c6.627 0 12 5.158 12 11.52 0 6.362-5.373 11.52-12 11.52S3 21.362 3 15C3 8.638 8.373 3.48 15 3.48zm3.497 12.897L15 19.735l-3.496-3.356-2.036 1.95.002.003L15 23.64l5.531-5.31.001-.001-2.035-1.952zM15 13.017l-1.525 1.465-.176.168-.361.347-.003.003.003.002L15 16.982l2.064-1.981.001-.001-.002-.001L15 13.018zm6.966.031l-2.034 1.953 2.034 1.952L24 15.001l-2.034-1.953zm-13.932-.001L6 15l2.034 1.952L10.068 15l-2.034-1.953zM15 6.36l-5.53 5.308 2.034 1.953L15 10.265l3.497 3.358 2.034-1.953L15 6.36z",
  fill: "#F3BA2F"
});

function SvgBnb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "cd76ce81db2a11e94298ace7fd8a67f8.svg";
export { SvgBnb as ReactComponent };